import React from 'react';
function PackageCar() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.8 108.8">
			<g id="Layer_2" data-name="Layer 2">
				<g id="Base_Circle" data-name="Base Circle">
					<path d="M54.4,3A51.4,51.4,0,1,1,3,54.4,51.46,51.46,0,0,1,54.4,3m0-3a54.4,54.4,0,1,0,54.4,54.4A54.4,54.4,0,0,0,54.4,0Z" />
				</g>
				<g id="Car">
					<path className="cls-1" d="M81.49,48.25H27.31a4.91,4.91,0,0,0-4.91,4.91V65.92a4.9,4.9,0,0,0,3.79,4.77v6.89a2.14,2.14,0,0,0,2.13,2.13h3.89a2.14,2.14,0,0,0,2.13-2.13V70.83h38.9v6.72a2.17,2.17,0,0,0,2.16,2.16h3.83a2.17,2.17,0,0,0,2.16-2.16V70.83h.08a4.91,4.91,0,0,0,4.91-4.91V53.16A4.91,4.91,0,0,0,81.49,48.25Z" />
					<path className="cls-1" d="M30.27,47.94V35.39a4.31,4.31,0,0,1,4.31-4.31H73a4.31,4.31,0,0,1,4.31,4.31V47.94" />
					<ellipse className="cls-1" cx="30.4" cy="58.08" rx="3.47" ry="3.68" />
					<ellipse className="cls-1" cx="77.33" cy="58.08" rx="3.47" ry="3.68" />
					<line className="cls-1" x1="26.19" y1="70.69" x2="82.01" y2="70.78" />
				</g>
			</g>
		</svg>
	);
}
export default PackageCar;


/** WEBPACK FOOTER **
 ** ./src/modules/images/PackageCar.js
 **/